import "./filtros.css";
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InputDate, Label, Boton, Input } from "asocomponents"
import { addFiltrosJuicio, addFiltroRapidoJuicio, setFiltrosCargados } from '../../../redux/filtroJuiciosSlice'
import ExportarExcel from "../ExportarExcel/ExportarExcel"
import SelectEstadoJuicio from "../Selects/SelectEstadosJuicio/SelectEstadosJuicio";

export default function FiltroJuicios() {
    const dispatch = useDispatch()
    const fechaActual = new Date()
    const filtrosCargados = useSelector(state => state.rootReducer.filtrosJuicios.cargados)
    const dataGrillaJuicios = useSelector(state => state.rootReducer.resultadoGrillaJuicios.dataGrillaJuicio)
    const usuarioString = sessionStorage.getItem('usuario') ? JSON.parse(sessionStorage.getItem('usuario')) : null;
    const camposExportarExcel = ["fechaNotificacion", "idJuicio", "tipoJuicio", "caratula", "nroSiniestro", "estado"]
    const cuitLetrado = usuarioString?.usuario

    fechaActual.setDate(fechaActual.getDate() + 1)
    fechaActual.setHours(0, 0, 0, 0) // Establecer la hora, minutos, segundos y milisegundos a 0

    const fechaMenos365Dias = new Date()
    fechaMenos365Dias.setDate(fechaMenos365Dias.getDate() - (365*10)) // 365*10 = diez año para atras

    const [isOpen, setIsOpen] = useState(false)
    const [nroRaj, setNroRaj] = useState()
    const [nroSiniestro, setNroSiniestro] = useState("")
    const [fechaNotificacionInicio, setFechaNotificacionInicio] = useState(fechaMenos365Dias.toISOString().split('T')[0])
    const [fechaNotificacionFin, setFechaNotificacionFin] = useState(fechaActual.toISOString().split('T')[0])
    const [idEstado, setIdEstado] = useState(-2)
    const [nroJuicio, setNroJuicio] = useState("")
    const [textoBusqueda, setTextoBusqueda] = useState('')
    const [palabraBuscar, setPalabraBuscar] = useState()

    const handleFiltros = () => {
        const filtros = {
            fechaNotificacionInicio: fechaNotificacionInicio,
            fechaNotificacionFin: fechaNotificacionFin,
            nroJuicio: nroJuicio,
            textoBusqueda: textoBusqueda,
            nroRaj: nroRaj,
            nroSiniestro: nroSiniestro,
            cuitLetrado: cuitLetrado,
            idEstadoJuicio: idEstado
        }

        dispatch(addFiltrosJuicio(filtros))
        dispatch(setFiltrosCargados(!filtrosCargados))

        toggleMenu()
    }

    const handleNroRaj = (valor) => {
        setNroRaj(valor)
    }

    const handleNroJuicio = (valor) => {
        setNroJuicio(valor)
    }

    const handleNroSiniestro = (valor) => {
        setNroSiniestro(valor)
    }

    const handlefechaNotificacionInicio = (valor) => {
        setFechaNotificacionInicio(valor)
    }

    const handlefechaNotificacionFin = (valor) => {
        setFechaNotificacionFin(valor)
    }

    const handleTextoBusqueda = (valor) => {
        setTextoBusqueda(valor)
    }

    const handleEstado = async (event) => {
        setIdEstado(event.target.value)
    }

    const handlePalabraBuscar = (valor) => {
        setPalabraBuscar(valor)
        if (valor.length > 3) {
            dispatch(addFiltroRapidoJuicio(valor))
        }
        else {
            dispatch(addFiltroRapidoJuicio(''))
        }
    }
    const toggleMenu = () => {
        setIsOpen(!isOpen)
        localStorage.setItem("filtrosOpen", (!isOpen).toString())
    }

    useEffect(() => {
        handleFiltros()
    }, [])



    return (
        <>
            <div className="flex flex-row justify-between m-3 w-[99%]">
                <div className="flex justify-start">
                    <Input placeholder="Buscar" type="text" valor={palabraBuscar} onChange={handlePalabraBuscar} width="w-44" /> <Boton icono="filtro" onClick={toggleMenu} alt="Ver Filtros" colorIcon="#5a5a5a" />
                </div>
            </div>
            <div className={`overlay ${!isOpen ? "open" : ""}`} onClick={toggleMenu}></div>
            <div className={`floating-filtros ${isOpen ? "open" : ""}`}>
                <div className="filtros-content">
                    <div className="flex flex-row justify-between items-center">
                        <Label texto="FILTROS" size="text-m" /> <Boton icono="quitar" onClick={toggleMenu} alt="Cerrar" />
                    </div>
                    <div><hr /></div>
                    <div className="flex flex-col mt-8">
                        <div className="flex flex-row ml-5">
                            <div className="text-left w-[50%]">
                                <Label texto="Fecha Notif. Desde" />
                            </div>
                            <div className="text-left w-[50%]">
                                <Label texto="Fecha Notif. Hasta" /></div>
                        </div>
                        <div className="flex flex-row">
                            <div className="text-left w-[50%]">
                                <InputDate valor={fechaNotificacionInicio} onChange={handlefechaNotificacionInicio} />
                            </div>
                            <div className="text-left w-[50%]">
                                <InputDate valor={fechaNotificacionFin} onChange={handlefechaNotificacionFin} />
                            </div>
                        </div>
                        <div className="flex flex-row ml-5 mt-3">
                            <div className="text-left w-[50%]">
                                <Label texto="Caratula" />
                            </div>
                            <div className="text-left w-[50%]">
                                <Label texto="Nro. Raj" /></div>
                        </div>
                        <div className="flex flex-row">
                            <div className="text-left w-[50%] ml-3">
                                <Input type="text" valor={textoBusqueda} onChange={handleTextoBusqueda} width="w-32" />
                            </div>
                            <div className="text-left w-[50%]">
                                <Input type="text" valor={nroRaj} onChange={handleNroRaj} width="w-32" />
                            </div>
                        </div>
                        <div className="flex flex-row ml-5 mt-3">
                            <div className="text-left w-[50%]">
                                <Label texto="Nro. Juicio" />
                            </div>
                            <div className="text-left w-[50%]">
                                <Label texto="Nro. Siniestro" /></div>
                        </div>
                        <div className="flex flex-row">
                            <div className="text-left w-[50%] ml-3">
                                <Input type="text" valor={nroJuicio} onChange={handleNroJuicio} width="w-32" />
                            </div>
                            <div className="text-left w-[50%]">
                                <Input type="text" valor={nroSiniestro} onChange={handleNroSiniestro} width="w-32" placeholder="XX-XXXXXX" />
                            </div>
                        </div>
                        <div className="flex flex-row ml-5 mt-3">
                            <div className="text-left w-[50%]">
                                <Label texto="Estado" />
                            </div>
                            <div className="text-left w-[50%]">
                            </div>
                        </div>
                        <div className="flex flex-row">
                            <div className="text-left w-[50%] ml-3">
                                <SelectEstadoJuicio onChange={handleEstado} width="w-32" valor={idEstado} />
                            </div>
                            <div className="text-left w-[50%]">
                            </div>
                        </div>
                        <div className="flex flex-row ml-5 mt-6 mb-3 justify-center items-center">
                            <Boton texto="Aplicar" fondo="rojo" onClick={handleFiltros} alt="Buscar" height="h-8" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-end">
                <div className="flex justify-end mr-5">
                    <ExportarExcel data={dataGrillaJuicios} nombreArchivo={"ReporteJuiciosAsociart"} camposSeleccionados={camposExportarExcel} />
                </div></div>
        </>
    )
}
